// Side-effect polyfill import must come first — see lib/polyfills.ts.
import "./lib/polyfills";

import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";

hydrateRoot(document, <StartClient />);

// Service worker registration is owned by PWAUpdateNotifier (AppShell).
// Do not register /sw.js here — duplicate registrations fight over updates.
